import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Alert, Spinner } from "reactstrap";

// Le Player Remotion est compilé à part (comparator-aws/studio/story-video, npm run build:player)
// dans public/studio-player/studio-player.js : pikachu (CRA 3) ne sait pas compiler Remotion.
const SCRIPT = "/studio-player/studio-player.js";

let loading = null;
function loadPlayer() {
    if (window.TRCStoryPlayer) return Promise.resolve(window.TRCStoryPlayer);
    if (!loading) {
        loading = new Promise((resolve, reject) => {
            const s = document.createElement("script");
            s.src = SCRIPT;
            s.async = true;
            s.onload = () => (window.TRCStoryPlayer ? resolve(window.TRCStoryPlayer) : reject(new Error("Player introuvable")));
            s.onerror = () => { loading = null; reject(new Error("Impossible de charger le Player (" + SCRIPT + ")")); };
            document.body.appendChild(s);
        });
    }
    return loading;
}

// Aperçu animé d'une story : storyboard (API) + captures (URL présignées) → Player.
// onMarkers reçoit les repères de scènes pour la timeline ; ref.seekTo(frame) y saute.
export const StoryPlayer = forwardRef(function StoryPlayer({ storyboard, captures, onMarkers }, ref) {
    const el = useRef(null);
    const handle = useRef(null);
    const [error, setError] = useState(null);
    const [ready, setReady] = useState(false);

    useImperativeHandle(ref, () => ({ seekTo: (frame) => handle.current && handle.current.seekTo(frame) }), []);

    useEffect(() => {
        let cancelled = false;
        loadPlayer()
            .then((P) => {
                if (cancelled || !el.current) return;
                const res = P.toPlayerProps(storyboard, captures);
                if (!res.ok) { setError(res.error); return; }
                setError(null);
                if (onMarkers) onMarkers(P.sceneMarkers(res.props));
                if (handle.current) handle.current.update(res.props);
                else handle.current = P.mount(el.current, res.props);
                setReady(true);
            })
            .catch((e) => !cancelled && setError(e.message));
        return () => { cancelled = true; };
    }, [storyboard, captures, onMarkers]);

    useEffect(() => () => { if (handle.current) handle.current.unmount(); handle.current = null; }, []);

    return (
        <div>
            {!ready && !error && <div className="text-center p-4"><Spinner size="sm" /> Chargement de l'aperçu…</div>}
            {error && <Alert color="warning">Aperçu indisponible : {error}</Alert>}
            <div ref={el} style={{ maxWidth: 360, margin: "0 auto", display: error ? "none" : "block" }} />
        </div>
    );
});
